import SweepManager from "./mp/sweep-manager";
import SceneManager from "./mp/scene-manager";
import sweepButtons from "./components/sweep-button";
import devTools from './dev-tools';

import { Navigation } from "@nf/matterport-ui/src/js/index";
import initializeSiteMap from "@nf/site-map/src/js/index";

import { parseScene } from "./utils/scene";
import { getSweepParam } from "./utils/sweep";

function getSdk(iframe) {
    return new Promise((resolve, reject) => {
        iframe.addEventListener("load", async () => {
            const win = iframe.contentWindow;

            try {
                const sdk = await win.MP_SDK.connect(win);
                sdk.App.state.subscribe(state => {
                    if (state.phase == "appphase.playing") {
                        resolve(sdk);
                    }
                });
            } catch (err) {
                reject(err);
            }
        });
    });
}
window.getSdk = getSdk;

window.mpSdk = (async () => {
    const showcase = document.getElementById("showcase");
    const sdk = await getSdk(showcase);
    const debug = sessionStorage.getItem('debug') === '1';

    // Handle Horizontal Scrollbars
    app.query('[data-scroll="horizontal"]', (scrollbar) => {
        scrollbar.addEventListener('wheel', (event) => {
            event.preventDefault();
            scrollbar.scrollLeft += event.deltaY;
        });
    });

    // Handle Locate Buttons
    app.query('[data-handle="locate"]', (locate) => {
        locate.addEventListener('click', (event) => {
            event.preventDefault();
            let data = locate.hash.slice(1);
            let [sweep, rotation] = data.split('@');
            rotation = rotation.split(':');

            sdk.Sweep.moveTo(sweep, {
                transition: "transition.fly",
                transitionTime: 1000,
                rotation: { 
                    x: parseFloat(rotation[0]), y: parseFloat(rotation[1]) 
                },
            });
        });
    });

    // Handle Navbar
    const navbar = app.select('[data-handle="navbar"]');
    if (navbar) {
        const navigation = new Navigation(navbar);

        sdk.Sweep.current.subscribe({
            async onChanged(sweep) {
                if (navigation.root.classList.contains('active')) {
                    const action = navigation.root.querySelector('.current [data-action="submenu"]');
                    if (!action) {
                        return;
                    }
                    
                    const target = navigation.root.querySelector(action.dataset.target);
                    if (target.classList.contains('active')) {
                        await navigation.closeMenu(target, action);
                        target.classList.remove('active');
                    }
                }
            }
        });
    }

    initializeSiteMap();

    const sweepManager = new SweepManager(sdk);
    const sceneManager = SceneManager.fromJSON(sdk, parseScene());

    const ctx = {
        sdk,
        sweepManager,
        sceneManager,
    };

    if (debug) {
        devTools(sdk);
    }

    // Handle parameter for initial sweep
    const sweepParam = getSweepParam();
    if (sweepParam) {
        const [sid, rotX, rotY] = sweepParam;
        sdk.App.state.subscribe(state => {
            if (state.phase === sdk.App.Phase.PLAYING) {
                setTimeout(() => {
                    sdk.Sweep.moveTo(sid, {
                        rotation: { x: rotX, y: rotY },
                        transition: sdk.Sweep.Transition.FADEOUT,
                    });
                }, 500);
            }
        });
    }

    sweepButtons(ctx, "button[data-sweep]");

    // Parse runtime configuration
    let runtimeConfig = {
        hide_unknown: true,
    };

    {
        const runtimeConfigEl = document.getElementById("runtime");
        if (runtimeConfigEl) {
            runtimeConfig = { runtimeConfig, ...JSON.parse(runtimeConfigEl.textContent) };
        }
    }

    // Hide unknown sweeps
    if (!debug && runtimeConfig.hide_unknown) {
        //ctx.sweepManager.hideUnknown();
    }

    // Hide Loading Screen
    const loadingScreen = app.select('#loading-screen');
    if (loadingScreen) {
        loadingScreen.style.opacity = 0.0;
        await app.wait(300);
        loadingScreen.classList.add('hidden');
        
        app.query('a:not([href^="#"]):not([target])', (el) => {
            if (el.getAttribute('href').startsWith('http')) {
                return;
            }
            el.addEventListener('click', async (event) => {
                event.preventDefault();
                loadingScreen.classList.remove('hidden');
                await app.wait(10);
                loadingScreen.style.opacity = 1.0;
                await app.wait(300);
                
                window.location.href = el.href;
            });
        });
    }

    // Trigger custom ready event
    window.app.props.set('sdk', sdk);
    window.app.setState('ready', true, { sdk });

    return sdk;

})();
